import Keycloak from 'keycloak-js';
console.log("obj", JSON.parse(process.env.REACT_APP_KEYCLOAKCONFIG));
const keycloak = Keycloak(JSON.parse(process.env.REACT_APP_KEYCLOAKCONFIG));
export default keycloak;